// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__GhjrC","label":"Labeled_label__38sM-","divider":"Labeled_divider__3x0yY"};